import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import NewInstrument from './components/NewInstrument';
import EditInstrument from './components/EditInstrument';
import InstrumentsList from './components/InstrumentsList';

const Instruments = () => {
    const [listRequiresReload, setListRequiresReload] = useState(true);
    const [selectedInstrument, setSelectedInstrument] = useState();

    return (
        <Container>
            <Row>
                <Col md={12}>
                    <h3 className="page-title">Instruments Management</h3>
                    <h3 className="page-subhead subhead">Manage workspace instruments</h3>
                </Col>
            </Row>
            <Row>
                <Col md={8}>
                    <InstrumentsList setSelectedInstrument={setSelectedInstrument} setListRequiresReload={setListRequiresReload} listRequiresReload={listRequiresReload} />
                </Col>
                <Col md={4}>
                    {!selectedInstrument && <NewInstrument setSelectedInstrument={setSelectedInstrument} setListRequiresReload={setListRequiresReload} selectedInstrument={selectedInstrument} />}
                    {selectedInstrument && <EditInstrument setSelectedInstrument={setSelectedInstrument} setListRequiresReload={setListRequiresReload} selectedInstrument={selectedInstrument} />}
                </Col>
            </Row>
        </Container>
    );
};

export default Instruments;